// @flow
import cn from 'classnames';
import React from 'react';

import * as DataId from '../../dataIds';

import './style.pcss';

export const BurgerMenuIcon = ({
  onClick,
  isCross
}: {
  onClick: Function,
  isCross: boolean
}) => (
  <button
    className={cn('burger-menu-icon', { 'burger-menu--cross': isCross })}
    data-id={DataId.BURGER_MENU_BUTTON}
    onClick={onClick}
    tabIndex={0}
  >
    <div className='burger-menu-icon__wrap'>
      <div className={cn('burger-menu-icon__item', 'burger-menu-icon__first-item')} />
      <div className={cn('burger-menu-icon__item', 'burger-menu-icon__second-item')} />
      <div className={cn('burger-menu-icon__item', 'burger-menu-icon__third-item')} />
    </div>
  </button>
);
